"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Polygon = exports.Path = exports.Svg = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-ICONS [ ACCOUNT ICON > STYLING ] ##################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2.1. BUILD SIZE


var buildSize = function buildSize(SIZE) {
  switch (SIZE) {
    case 'small':
      return 'var(--gutter)';

    case 'large':
      return 'var(--gutter-large)';

    default:
      return 'var(--gutter-medium)';
  }
}; // 2.1. END
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. SVG ....................................................................


var Svg = _styledComponents["default"].svg.withConfig({
  displayName: "style__Svg",
  componentId: "sc-1wgvuun-0"
})(["width:", ";height:", ";"], function (_ref) {
  var iconSize = _ref.iconSize;
  return buildSize(iconSize);
}, function (_ref2) {
  var iconSize = _ref2.iconSize;
  return buildSize(iconSize);
}); // 3.1. END ....................................................................
// 3.2. PATH ...................................................................


exports.Svg = Svg;

var Path = _styledComponents["default"].path.withConfig({
  displayName: "style__Path",
  componentId: "sc-1wgvuun-1"
})(["fill:", ";"], function (_ref3) {
  var pathColor = _ref3.pathColor;
  return pathColor ? pathColor : 'var(--color-dark)';
}); // 3.2. END ....................................................................
// 3.3. POLYGON ................................................................


exports.Path = Path;

var Polygon = _styledComponents["default"].polygon.withConfig({
  displayName: "style__Polygon",
  componentId: "sc-1wgvuun-2"
})(["fill:", ";"], function (_ref4) {
  var polygonColor = _ref4.polygonColor;
  return polygonColor ? polygonColor : 'var(--color-dark)';
}); // 3.3. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.Polygon = Polygon;